module.exports = __webpack_public_path__ + "static/media/r_itdot_10.7ea88624.png";